const rankings = [
  {
    rank: 1,
    title: '江湖风云录',
    type: '古装武侠剧',
    heat: '9.8',
    tag: '霸榜3周',
    tagColor: 'bg-accent-500',
    desc: '年度口碑武侠巨制，全员演技在线，剧情扣人心弦。',
  },
  {
    rank: 2,
    title: '星际迷航：新纪元',
    type: '科幻冒险片',
    heat: '9.6',
    tag: '新上榜',
    tagColor: 'bg-primary-500',
    desc: '视觉特效炸裂，IMAX级观影体验，科幻迷不容错过。',
  },
  {
    rank: 3,
    title: '长安十二时辰',
    type: '悬疑古装剧',
    heat: '9.5',
    tag: '全集上线',
    tagColor: 'bg-accent-500',
    desc: '烧脑悬疑与盛唐美学的完美结合，第二季口碑爆棚。',
  },
  {
    rank: 4,
    title: '深海历险',
    type: '动画冒险片',
    heat: '9.3',
    tag: '亲子推荐',
    tagColor: 'bg-secondary-500',
    desc: '国产动画天花板，画面精美剧情温暖，适合全家观看。',
  },
  {
    rank: 5,
    title: '城市猎人2026',
    type: '都市动作剧',
    heat: '9.1',
    tag: '热播中',
    tagColor: 'bg-primary-500',
    desc: '韩式动作美学，节奏紧凑全程高能，每集都像看电影。',
  },
  {
    rank: 6,
    title: '迷雾追踪',
    type: '悬疑推理剧',
    heat: '8.9',
    tag: '口碑上升',
    tagColor: 'bg-secondary-500',
    desc: '国产悬疑黑马，反转不断，豆瓣评分持续走高。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时热门影视排行，看看大家都在看什么
          </p>
        </div>

        <div className="space-y-3">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 font-heading font-bold text-sm md:text-base ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-400 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-400 flex-shrink-0">{item.type}</span>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`hidden sm:inline-block px-2 py-0.5 text-xs font-medium text-background-50 ${item.tagColor} rounded whitespace-nowrap`}>
                  {item.tag}
                </span>
                <div className="flex items-center gap-1">
                  <i className="ri-fire-line text-sm text-accent-500"></i>
                  <span className="text-sm font-semibold text-accent-600">{item.heat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}